import type { RunMetricOutput } from "@/types/RunMetricOutput"

import {
  getJudgeConfidence,
  type JudgeConfidenceOptions,
} from "./judgeConfidence"
import { JudgeConfidenceDetail } from "./JudgeConfidenceDetail"
import { getLegacyDecisionEstimate } from "./legacyDecisionEstimate"
import { LegacyDecisionEstimateDetail } from "./LegacyDecisionEstimateDetail"

interface DeepDiveSection {
  label: string
  content: React.ReactNode
}

/** Recorded result data keeps confidence independent of current metric settings. */
export function appendJudgeConfidence(
  sections: DeepDiveSection[] | null,
  metricOutput: RunMetricOutput,
  options?: JudgeConfidenceOptions,
): DeepDiveSection[] | null {
  const confidence = getJudgeConfidence(metricOutput, options)
  if (confidence !== null) {
    return [
      ...(sections ?? []).filter((section) => section.label !== "Confidence"),
      {
        label: "Coval Judge confidence",
        content: <JudgeConfidenceDetail confidence={confidence} />,
      },
    ]
  }
  const calibration = getLegacyDecisionEstimate(metricOutput)
  if (calibration === null) {
    return sections
  }
  return [
    ...(sections ?? []),
    {
      label: "Historical decision estimate",
      content: <LegacyDecisionEstimateDetail calibration={calibration} />,
    },
  ]
}
